import React from 'react'
import PropTypes from 'prop-types'

import * as Component from './Container.styles'

/**
 * Generic Container Component
 */
const Container = ({ className, isFlat, children, ...rest }) => (
  <Component.Container isFlat={ isFlat } className={ className } { ...rest }>
    {children}
  </Component.Container>
)

Container.propTypes = {
  /** The CSS class name of the input wrapper element. */
  className: PropTypes.string,
  /** for adding child nodes */
  children: PropTypes.node.isRequired,
  /** for toggling box-shadow */
  isFlat: PropTypes.bool,
}

export default Container
